(() => {
  const ObserveIntersection = (selector, config, callback) => {
    let $selector = document.querySelector(selector);
    if (!$selector) return;

    var observer = new IntersectionObserver(callback, config);
    var config = {};
    observer.observe($selector, config);
  
    return observer;
  }

  // set label % from the bottom
  function getLabelBelowPosition(value) {
    return value * 0.05;
  }

  function getLabelAbovePosition(value, maxYValue) {
    if (value == 0) return maxYValue - (maxYValue * 0.95);

    return value + (maxYValue * 0.05);
  }

  function isLessThanFifteenPercent(value, number) {
    return value < (number * 0.15);
  }

  const GetLabels = (p_options) => {
    let labels              = [];
    let { chartName, stepSize, chartYMaxHeight } = p_options;

    // set each label
    p_options.data.forEach((item, itemIndex) => {
      let label;
      let item_value          = parseFloat(item.value.replace(',', ''));
      let yValue              = (item_value * 1.1);
      let positionLabelAbove  = true;

      let xGap = p_options.xGap;
          xGap = xGap.length ? xGap[itemIndex] : xGap;

      let yGap = p_options.yGap;
          yGap = yGap.length ? yGap[itemIndex] : yGap;

      if (chartName == 'CHART_1_BAR' || chartName == 'CHART_2_BAR') {
        // set label above if the value is less that 15% of the total
        isLessThanFifteenPercent(item_value, chartYMaxHeight)
          ? positionLabelAbove = true
          : positionLabelAbove = false;

        yValue = positionLabelAbove
          ? getLabelAbovePosition(item_value, chartYMaxHeight)
          : getLabelBelowPosition(chartYMaxHeight);

      } else if (chartName == 'CHART_1_DOTS' || chartName == 'CHART_2_DOTS') {
        yValue = getLabelAbovePosition(item_value, chartYMaxHeight)
      }


      let color   = positionLabelAbove ? p_options.color : '#FFF';
      let content = item.value ? `${ item.value }` : '';

      label = {
        type: 'label',
        xValue: (itemIndex + xGap),
        yValue: yValue,
        color: color,
        content: [content],
        font: {
          size: p_options.fontSize,
          weight: 500,
          lineHeight: 1.2
        },
        for: p_options.for
      };

      if (label) labels.push(label);
    });

    return labels;
  }

  // Strip text and gets the highest integer
  const GetMax = (values) => {
    values = values.map(value => parseFloat(value.replace(',', '')));
    return Math.max(...values);
  }


  /**
  * Calcutate Step Size
  * - calculates the step size based on the highest Y value
  */
  function calculateStepsAndMaxYValue(value) {
    let stepSize, maxYValue;
    let ranges = [100, 500, 1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 20000, 100000, 1000000];

    if (value <= 1) {
      stepSize = .1;

    } else if (value >= 1 && value <= 10) {
      stepSize = 1;

    } else if (value < 50) {
      stepSize = 5;

    } else {
      for (let i = 0; i < ranges.length; i++) {
        if (value < ranges[i]) {
          stepSize = ranges[i] / 10;
          break;
        }
      }
    }

    maxYValue = Math.ceil((value + stepSize) / stepSize) * stepSize;

    // Ensure maxYValue is a clean number divisible by 10
    if (value <= 1) {
      if(value >= 0.91 && value <= 1) {
        maxYValue = 1.2;

      } else {
        maxYValue = 1;
      }

    } else if (value <= 8) {
      maxYValue = 10;

    } else if (value > 8 && value <= 10) {
      maxYValue = 12;

    } else if (value > 10 && value <= 15) {
      maxYValue = 20;

    } else {
      maxYValue = Math.ceil(maxYValue / 10) * 10 + stepSize;
    }

    // set a max for empty charts
    if (!maxYValue) {
      maxYValue = 1;
    }


    return { stepSize, maxYValue };
  }


  const InitCharts = () => {
    if (!PRODUCT_DATA) return;

    let selected_variant = PRODUCT_DATA.variants.find(v => v.selected);

    if (!selected_variant) return;
    let CHART_DATA = selected_variant.CHART_DATA;

    let isInitialized = document.querySelectorAll('.product-charts.init').length;
    if (isInitialized) return;

    let isMobile = matchMedia('(max-width: 600px)').matches;
    let settings = {
      font: {
        scaleX: isMobile ? 10 : 15,
        scaleY: isMobile ? 6 : 10,
        labels: isMobile ? 10 : 15
      }
    }

    // CHART #1
    const DATA_CHART_1_BAR  = CHART_DATA.data_chart_1_bar;
    const DATA_CHART_1_DOTS = CHART_DATA.data_chart_1_dots;

    const DATA_CHART_1_MAX_Y = GetMax([
      ...DATA_CHART_1_BAR.map(item => item.value),
      ...DATA_CHART_1_DOTS.map(item => item.value)
    ]);

    let chart1Settings         = calculateStepsAndMaxYValue(DATA_CHART_1_MAX_Y);
    let chart1StepSize         = chart1Settings.stepSize;
    const dataChart1MaxYHeight = chart1Settings.maxYValue;

    const LABELS_CHART_1_BAR = GetLabels({
      data: DATA_CHART_1_BAR, 
      color: '#046E82', 
      unit: '',
      xGap: 0,
      yGap: 3.25,
      fontSize: settings.font.labels,
      chartYMax: DATA_CHART_1_MAX_Y,
      chartYMaxHeight: dataChart1MaxYHeight,
      stepSize: chart1StepSize,
      for: 'bar',
      chartName: 'CHART_1_BAR'
    });

    const LABELS_CHART_1_DOTS = GetLabels({
      data: DATA_CHART_1_DOTS, 
      color: '#09AD50', 
      unit: '',
      xGap: 0,
      yGap: 7,
      fontSize: settings.font.labels,
      for: 'scatter',
      chartYMaxHeight: dataChart1MaxYHeight,
      chartName: 'CHART_1_DOTS'
    });

    const CONFIG_CHART_1 = {
      data: {
        labels: DATA_CHART_1_BAR.map(item => item.label),
        datasets: [
          {
            type: 'scatter',
            pointRadius: isNaN(DATA_CHART_1_MAX_Y)  ? 0 : 2,
            pointHoverRadius: 2,
            xAxisID: 'DOTS',
            backgroundColor: '#09AD50',
            order: 2,
            data: (() => {
              let d = new Array(isMobile ? 9 : 11).fill('x');
              return d.map((item, index) => {
                return {
                  x: isMobile ? (index * 10/8) : index,
                  y: DATA_CHART_1_DOTS[0] ? DATA_CHART_1_DOTS[0].value : null
                }
              });
            })()
          },
          {
            type: 'bar',
            data: DATA_CHART_1_BAR.map(item => parseFloat(item.value.replace(',', ''))),
            label: false,
            backgroundColor: 'rgba(4, 110, 130, 0.5)',
            borderColor: '#046E82',
            borderRadius: 10,
            borderWidth: 2,
            minBarThickness: 55,
            maxBarThickness: 58,
            order: 1
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          },
          annotation: {
            annotations: (() => {
              return [].concat(LABELS_CHART_1_BAR, LABELS_CHART_1_DOTS);
            })()
          }      
        },
        scales: {
          x: {
            ticks: {
              color: '#046E82',
              font: {
                size: settings.font.scaleX,
                weight: 600,
                lineHeight: 1
              },
            },
            grid: {
              drawOnChartArea: false,
              color: 'transparent'
            }
          },
          y: {
            min: 0,
            max: dataChart1MaxYHeight,
            title: {
              text: CHART_DATA.chart_1_title !== '' ? CHART_DATA.chart_1_title : '',
              display: true,
              align: 'start',
              font: {
                size: settings.font.scaleY,
                weight: 400
              }
            },
            ticks: {
              stepSize: chart1StepSize,
              font: {
                size: settings.font.scaleY
              }
            },
          },
          DOTS: {
            position: 'bottom',
            border: {
              color: 'transparent',
              width: 0
            },
            grid: {
              drawOnChartArea: false,
              display: false,
              color: 'transparent'
            }
          },
        },
        animation: {
          duration: 800,
          easing: 'linear',
          delay: 500
        }
      }
    };

    const CHART_1 = new Chart('chartContainer-1', CONFIG_CHART_1);

    // CHART #2
    const DATA_CHART_2_BAR    = CHART_DATA.data_chart_2_bar;
    const DATA_CHART_2_DOTS   = CHART_DATA.data_chart_2_dots;

    const DATA_CHART_2_MAX_Y = GetMax([
      ...DATA_CHART_2_BAR.map(item => item.value),
      ...DATA_CHART_2_DOTS.map(item => item.value)
    ]);

    let chart2Settings         = calculateStepsAndMaxYValue(DATA_CHART_2_MAX_Y);
    let chart2StepSize         = chart2Settings.stepSize;
    const dataChart2MaxYHeight = chart2Settings.maxYValue;

    const LABELS_CHART_2_BAR = GetLabels({
      data: DATA_CHART_2_BAR,
      color: '#046E82',
      unit: '',
      xGap: 0,
      yGap: 3.25,
      fontSize: settings.font.labels,
      chartYMax: DATA_CHART_2_MAX_Y,
      chartYMaxHeight: dataChart2MaxYHeight,
      stepSize: chart2StepSize,
      for: 'bar',
      chartName: 'CHART_2_BAR'
    })

    const LABELS_CHART_2_DOTS = GetLabels({
      data: DATA_CHART_2_DOTS,
      color: '#ff0000',
      unit: '',
      xGap: 0,
      yGap: 7,
      fontSize: settings.font.labels,
      for: 'scatter',
      chartYMaxHeight: dataChart2MaxYHeight,
      chartName: 'CHART_2_DOTS'
    });


    const CONFIG_CHART_2 = {
      data: {
        labels: DATA_CHART_2_BAR.map(item => item.label),
        datasets: [
          {
            type: 'scatter',
            pointRadius: 2,
            pointHoverRadius: 2,
            xAxisID: 'DOTS',
            backgroundColor: '#FF0000',
            data: (() => {
              let data = [];
              let num_dots = isNaN(DATA_CHART_1_MAX_Y) ? 0 : 10;
              CHART_DATA.data_chart_2_dots.forEach((dots, dots_index) => {
                for(var i = 0; i < num_dots; i++) {
                  data.push({
                    x: i + (dots_index * num_dots),
                    y: dots.value
                  });

                  // add an extra
                  if (i == num_dots - 1) {
                    data.push({
                      x: i + (dots_index * num_dots) + 1,
                      y: dots.value
                    });
                  }
                }
              });
              return data;
            })()
          },
          {
            type: 'bar',
            data: DATA_CHART_2_BAR.map(item => item.value),
            label: false,
            backgroundColor: 'rgba(4, 110, 130, 0.5)',
            borderColor: '#046E82',
            borderRadius: 10,
            borderWidth: 2,
            maxBarThickness: 55
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          },
          annotation: {
            annotations: (() => {
              return [].concat(LABELS_CHART_2_BAR, LABELS_CHART_2_DOTS);
            })()
          }
        },
        scales: {
          x: {
            ticks: {
              color: '#046E82',
              font: {
                size: settings.font.scaleX,
                weight: 600,
                lineHeight: 1
              }
            },
            grid: {
              drawOnChartArea: false,
              color: 'transparent'
            }
          },
          y: {
            min: 0,
            max: dataChart2MaxYHeight,
            title: {
              text: CHART_DATA.chart_2_title !== '' ? CHART_DATA.chart_2_title : '',
              display: true,
              align: 'start',
              font: {
                size: settings.font.scaleY,
                weight: 400
              }
            },
            ticks: {
              stepSize: chart2StepSize,
              font: {
                size: settings.font.scaleY
              }
            }
          },
          DOTS: {
            position: 'bottom',
            border: {
              color: 'transparent',
              width: 0
            },
            grid: {
              drawOnChartArea: false,
              display: false,
              color: 'transparent'
            }
          }
        },
        animation: {
          duration: 800,
          easing: 'linear',
          delay: 500
        }
      }
    };

    const CHART_2 = new Chart("chartContainer-2", CONFIG_CHART_2);

    document.querySelector('.product-charts').classList.add('init');

    document.querySelector('.chart-link a').href = CHART_DATA.chart_link;
  }

  const DOMReady = () => {
    let config = {
      rootMargin: "0px 0px -30% 0px"
    };
    let callback = (m_entries) => {
      if (m_entries.length && m_entries[0].isIntersecting) {
        document.dispatchEvent(new CustomEvent('init-charts'));
      }
    }
    ObserveIntersection('.product-charts', config, callback);
  }

  document.addEventListener('init-charts', (e) => {
    InitCharts();
  });

  document.addEventListener('destroy-charts', (e) => {
    Chart.helpers.each(Chart.instances, function(instance){
      instance.destroy();
    });
    document.querySelectorAll('.product-charts.init').forEach(($chart) => {
      $chart.classList.remove('init');
    });
  });

  // on variant-change
  document.addEventListener('variant-change', (e) => {
    let variant = e.detail.variant;
    if (!variant || typeof PRODUCT_DATA == 'undefined') return;

    PRODUCT_DATA.variants.forEach((v) => v.selected = false);
    PRODUCT_DATA.variants.find(v => v.id == variant.id).selected = true;

    document.dispatchEvent(new CustomEvent('destroy-charts'));

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('init-charts'));
    }, 0);
  });

  document.addEventListener('DOMContentLoaded', DOMReady);
})();